
/* Gohall cart empty drawer final alignment 2026-06-03 v3 */
const GOHALL_EMPTY_CART_CSS = `
cart-drawer-component.gohall-cart-empty-state,
.cart-drawer--empty,
.gohall-cart-empty-state{--gohall-cart-empty-max:330px}
cart-drawer-component.gohall-cart-empty-state .cart-drawer__inner,
.cart-drawer--empty .cart-drawer__inner,
.gohall-cart-empty-state .cart-drawer__inner{min-height:100dvh;display:flex;flex-direction:column}
cart-drawer-component.gohall-cart-empty-state .cart-drawer__header,
.cart-drawer--empty .cart-drawer__header,
.gohall-cart-empty-state .cart-drawer__header{min-height:58px;flex:0 0 auto}
cart-drawer-component.gohall-cart-empty-state .cart-drawer__close,
.cart-drawer--empty .cart-drawer__close,
.gohall-cart-empty-state .cart-drawer__close{margin-left:auto}
cart-drawer-component.gohall-cart-empty-state .cart-drawer__content,
.cart-drawer--empty .cart-drawer__content,
.gohall-cart-empty-state .cart-drawer__content{flex:1 1 auto;min-height:calc(100dvh - 58px);width:100%;display:flex!important;align-items:center!important;justify-content:center!important;padding:28px 24px 88px!important;overflow-x:hidden!important;text-align:center!important}
cart-drawer-component.gohall-cart-empty-state cart-items-component,
.cart-drawer--empty cart-items-component,
.gohall-cart-empty-state cart-items-component{width:100%;max-width:var(--gohall-cart-empty-max);margin:0 auto!important;display:flex!important;flex-direction:column;align-items:center!important;justify-content:center!important;text-align:center!important}
cart-drawer-component.gohall-cart-empty-state .cart-title,
.cart-drawer--empty .cart-title,
.gohall-cart-empty-state .cart-title{width:100%!important;max-width:var(--gohall-cart-empty-max);margin:0 auto 8px!important;padding:0!important;display:block!important;text-align:center!important;position:static!important;inset:auto!important;transform:none!important}
cart-drawer-component.gohall-cart-empty-state .cart-title h1,
.cart-drawer--empty .cart-title h1,
.gohall-cart-empty-state .cart-title h1{width:100%!important;max-width:var(--gohall-cart-empty-max);margin:0 auto 6px!important;padding:0!important;display:block!important;color:#061935!important;font-size:clamp(25px,6vw,28px)!important;line-height:1.05!important;font-weight:850!important;letter-spacing:0!important;text-align:center!important;white-space:normal!important;overflow-wrap:normal!important;text-indent:0!important;transform:none!important;position:static!important;left:auto!important;right:auto!important}
cart-drawer-component.gohall-cart-empty-state .cart-items__wrapper,
.cart-drawer--empty .cart-items__wrapper,
.gohall-cart-empty-state .cart-items__wrapper{width:100%!important;max-width:var(--gohall-cart-empty-max);margin:0 auto!important;padding:0!important;display:flex!important;flex-direction:column;align-items:center!important;justify-content:center!important;text-align:center!important;position:static!important;inset:auto!important;transform:none!important}
cart-drawer-component.gohall-cart-empty-state .cart-items__wrapper p,
.cart-drawer--empty .cart-items__wrapper p,
.gohall-cart-empty-state .cart-items__wrapper p{width:100%;margin:0 auto 22px!important;color:#243552;font-size:15px;line-height:1.45;text-align:center!important}
cart-drawer-component.gohall-cart-empty-state .cart-items__empty-button,
.cart-drawer--empty .cart-items__empty-button,
.gohall-cart-empty-state .cart-items__empty-button{width:min(230px,100%)!important;min-height:52px;margin:0 auto!important;display:inline-flex!important;align-items:center;justify-content:center;border-radius:8px!important;background:#0030a8!important;color:#fff!important;font-size:16px!important;font-weight:800!important;line-height:1!important;text-align:center!important}
.cart-page--empty{width:100%;min-height:min(620px,calc(100dvh - 80px));display:flex!important;flex-direction:column;align-items:center!important;justify-content:center!important;text-align:center!important;padding:32px 24px 88px!important;overflow-x:hidden!important}
.cart-page--empty .cart-page__title,.cart-page--empty .cart-page__items{width:100%!important;max-width:330px!important;margin:0 auto!important;padding:0!important;text-align:center!important}
.cart-page--empty .cart-title,.cart-page--empty .cart-title.text-left,.cart-page--empty .cart-title h1{width:100%!important;max-width:330px!important;margin:0 auto 8px!important;padding:0!important;display:block!important;position:static!important;left:auto!important;right:auto!important;transform:none!important;text-align:center!important;text-indent:0!important}
.cart-page--empty .cart-title h1{color:#061935!important;font-size:clamp(25px,6vw,28px)!important;line-height:1.05!important;font-weight:850!important;letter-spacing:0!important;white-space:normal!important}
.cart-page--empty .cart-items__wrapper{width:100%!important;max-width:330px!important;margin:0 auto!important;padding:0!important;display:flex!important;flex-direction:column;align-items:center!important;justify-content:center!important;text-align:center!important}
.cart-page--empty .cart-items__wrapper p{width:100%;margin:0 auto 22px!important;color:#243552;font-size:15px;line-height:1.45;text-align:center!important}
.cart-page--empty .cart-items__empty-button{width:min(230px,100%)!important;min-height:52px;margin:0 auto!important;display:inline-flex!important;align-items:center;justify-content:center;border-radius:8px!important;background:#0030a8!important;color:#fff!important;font-size:16px!important;font-weight:800!important;line-height:1!important;text-align:center!important}
@media (max-width:520px){cart-drawer-component.gohall-cart-empty-state .cart-drawer__content,.cart-drawer--empty .cart-drawer__content,.gohall-cart-empty-state .cart-drawer__content{padding-inline:22px!important}}
`;
function ensureGohallEmptyCartStyle(){
  if (document.getElementById('gohall-cart-empty-style')) return;
  const style=document.createElement('style');
  style.id='gohall-cart-empty-style';
  style.textContent=GOHALL_EMPTY_CART_CSS;
  document.head.appendChild(style);
}
function findGohallCartScope(node){
  if (!node || node === document) return document.querySelector('cart-drawer-component') || document.querySelector('.cart-drawer') || document.querySelector('dialog');
  return node.closest?.('cart-drawer-component, .cart-drawer, dialog') || document.querySelector('cart-drawer-component') || document.querySelector('.cart-drawer') || document.querySelector('dialog');
}
function applyGohallEmptyCartAlignment(root = document) {
  ensureGohallEmptyCartStyle();
  const candidates = new Set();
  document.querySelectorAll('cart-drawer-component, .cart-drawer, dialog').forEach((scope) => candidates.add(scope));
  root.querySelectorAll?.('cart-drawer-component, .cart-drawer, dialog, .cart-title, .cart-items__wrapper, cart-items-component').forEach((node) => {
    const scope = findGohallCartScope(node);
    if (scope) candidates.add(scope);
  });
  const directScope = findGohallCartScope(root);
  if (directScope) candidates.add(directScope);

  candidates.forEach((scope) => {
    const hasEmptyButton = Boolean(scope.querySelector?.('.cart-items__empty-button'));
    const hasEmptyTitle = /your cart is empty/i.test(scope.textContent || '');
    if (!hasEmptyButton && !hasEmptyTitle) {
      scope.classList?.remove('gohall-cart-empty-state', 'cart-drawer--empty');
      return;
    }

    scope.classList.add('gohall-cart-empty-state');
    const dialog = scope.matches?.('dialog') ? scope : scope.querySelector?.('dialog');
    dialog?.classList.add('gohall-cart-empty-state', 'cart-drawer--empty');
    const host = scope.closest?.('cart-drawer-component') || scope.querySelector?.('cart-drawer-component');
    host?.classList.add('gohall-cart-empty-state');

    const content = scope.querySelector?.('.cart-drawer__content');
    if (content) {
      content.style.setProperty('display', 'flex', 'important');
      content.style.setProperty('align-items', 'center', 'important');
      content.style.setProperty('justify-content', 'center', 'important');
      content.style.setProperty('text-align', 'center', 'important');
      content.style.setProperty('overflow-x', 'hidden', 'important');
      content.style.setProperty('padding', '28px 24px 88px', 'important');
    }

    const items = scope.querySelector?.('cart-items-component');
    if (items) {
      items.style.setProperty('width', '100%', 'important');
      items.style.setProperty('max-width', '330px', 'important');
      items.style.setProperty('margin', '0 auto', 'important');
      items.style.setProperty('display', 'flex', 'important');
      items.style.setProperty('flex-direction', 'column', 'important');
      items.style.setProperty('align-items', 'center', 'important');
      items.style.setProperty('justify-content', 'center', 'important');
      items.style.setProperty('text-align', 'center', 'important');
    }

    const title = scope.querySelector?.('.cart-title');
    if (title) {
      title.style.setProperty('width', '100%', 'important');
      title.style.setProperty('max-width', '330px', 'important');
      title.style.setProperty('margin', '0 auto 8px', 'important');
      title.style.setProperty('padding', '0', 'important');
      title.style.setProperty('display', 'block', 'important');
      title.style.setProperty('text-align', 'center', 'important');
      title.style.setProperty('position', 'static', 'important');
      title.style.setProperty('transform', 'none', 'important');
    }

    const heading = scope.querySelector?.('.cart-title h1');
    if (heading) {
      heading.style.setProperty('display', 'block', 'important');
      heading.style.setProperty('width', '100%', 'important');
      heading.style.setProperty('max-width', '330px', 'important');
      heading.style.setProperty('margin', '0 auto 6px', 'important');
      heading.style.setProperty('padding', '0', 'important');
      heading.style.setProperty('color', '#061935', 'important');
      heading.style.setProperty('font-size', 'clamp(25px, 6vw, 28px)', 'important');
      heading.style.setProperty('line-height', '1.05', 'important');
      heading.style.setProperty('font-weight', '850', 'important');
      heading.style.setProperty('letter-spacing', '0', 'important');
      heading.style.setProperty('text-align', 'center', 'important');
      heading.style.setProperty('white-space', 'normal', 'important');
      heading.style.setProperty('text-indent', '0', 'important');
      heading.style.setProperty('position', 'static', 'important');
      heading.style.setProperty('transform', 'none', 'important');
    }

    const wrapper = scope.querySelector?.('.cart-items__wrapper');
    if (wrapper) {
      wrapper.style.setProperty('width', '100%', 'important');
      wrapper.style.setProperty('max-width', '330px', 'important');
      wrapper.style.setProperty('margin', '0 auto', 'important');
      wrapper.style.setProperty('padding', '0', 'important');
      wrapper.style.setProperty('display', 'flex', 'important');
      wrapper.style.setProperty('flex-direction', 'column', 'important');
      wrapper.style.setProperty('align-items', 'center', 'important');
      wrapper.style.setProperty('justify-content', 'center', 'important');
      wrapper.style.setProperty('text-align', 'center', 'important');
      wrapper.style.setProperty('position', 'static', 'important');
      wrapper.style.setProperty('transform', 'none', 'important');
    }
  });
}
function applyGohallCartPolish(root = document) {
  applyGohallEmptyCartAlignment(root);
  root.querySelectorAll('#cart-drawer-heading .cart-bubble, .cart-drawer__heading .cart-bubble').forEach((bubble) => bubble.remove());

  root.querySelectorAll('cart-drawer-component cart-quantity-selector-component.quantity-selector, .cart-drawer cart-quantity-selector-component.quantity-selector').forEach((selector) => {
    selector.style.setProperty('display', 'grid', 'important');
    selector.style.setProperty('grid-template-columns', '36px 38px 36px', 'important');
    selector.style.setProperty('align-items', 'center', 'important');
    selector.style.setProperty('justify-items', 'stretch', 'important');
    selector.style.setProperty('width', '110px', 'important');
    selector.style.setProperty('min-width', '110px', 'important');
    selector.style.setProperty('height', '38px', 'important');
    selector.style.setProperty('min-height', '38px', 'important');
    selector.style.setProperty('border', '1px solid rgba(11, 51, 163, 0.16)', 'important');
    selector.style.setProperty('border-radius', '9px', 'important');
    selector.style.setProperty('overflow', 'hidden', 'important');
    selector.style.setProperty('background', '#fff', 'important');
    selector.style.setProperty('box-shadow', '0 6px 16px rgba(11, 51, 163, 0.06)', 'important');

    selector.querySelectorAll('button').forEach((button) => {
      button.style.setProperty('display', 'inline-flex', 'important');
      button.style.setProperty('align-items', 'center', 'important');
      button.style.setProperty('justify-content', 'center', 'important');
      button.style.setProperty('width', '36px', 'important');
      button.style.setProperty('min-width', '36px', 'important');
      button.style.setProperty('height', '38px', 'important');
      button.style.setProperty('min-height', '38px', 'important');
      button.style.setProperty('padding', '0', 'important');
      button.style.setProperty('margin', '0', 'important');
      button.style.setProperty('border', '0', 'important');
      button.style.setProperty('border-radius', '0', 'important');
      button.style.setProperty('background', '#f4f7ff', 'important');
      button.style.setProperty('color', '#0b33a3', 'important');
      button.style.setProperty('box-shadow', 'none', 'important');
      button.style.setProperty('line-height', '1', 'important');
    });

    const input = selector.querySelector('input');
    if (input) {
      input.style.setProperty('width', '38px', 'important');
      input.style.setProperty('min-width', '38px', 'important');
      input.style.setProperty('height', '38px', 'important');
      input.style.setProperty('min-height', '38px', 'important');
      input.style.setProperty('padding', '0', 'important');
      input.style.setProperty('margin', '0', 'important');
      input.style.setProperty('border', '0', 'important');
      input.style.setProperty('background', '#fff', 'important');
      input.style.setProperty('color', '#111827', 'important');
      input.style.setProperty('font-weight', '750', 'important');
      input.style.setProperty('line-height', '38px', 'important');
      input.style.setProperty('text-align', 'center', 'important');
      input.style.setProperty('box-shadow', 'none', 'important');
      input.style.setProperty('appearance', 'textfield', 'important');
    }
  });

  root.querySelectorAll('.cart-items__remove').forEach((button) => {
    button.style.setProperty('display', 'inline-flex', 'important');
    button.style.setProperty('align-items', 'center', 'important');
    button.style.setProperty('justify-content', 'center', 'important');
    button.style.setProperty('width', '38px', 'important');
    button.style.setProperty('min-width', '38px', 'important');
    button.style.setProperty('height', '38px', 'important');
    button.style.setProperty('min-height', '38px', 'important');
    button.style.setProperty('border-radius', '9px', 'important');
    button.style.setProperty('background', '#f4f7ff', 'important');
    button.style.setProperty('color', '#0b33a3', 'important');
    button.style.setProperty('border', '1px solid rgba(11, 51, 163, 0.14)', 'important');
    button.style.setProperty('box-shadow', '0 6px 16px rgba(11, 51, 163, 0.05)', 'important');
  });
}

const schedulePolish = () => {
  applyGohallEmptyCartAlignment();
  requestAnimationFrame(() => applyGohallCartPolish());
  setTimeout(() => applyGohallCartPolish(), 80);
  setTimeout(() => applyGohallCartPolish(), 350);
  setTimeout(() => applyGohallCartPolish(), 900);
};

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (target?.closest('[data-testid="cart-drawer-trigger"], cart-drawer-component, .header-actions__cart-icon')) {
    schedulePolish();
  }
}, true);

document.addEventListener('DOMContentLoaded', schedulePolish);
new MutationObserver(schedulePolish).observe(document.documentElement, { childList: true, subtree: true });


